import { useState } from "react";
import { Share2, Facebook, Link2, Check } from "lucide-react";
import { toast } from "sonner";
import { Button } from "../ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "../ui/dropdown-menu";
import { openFacebookShare } from "../../lib/api";
import { basarShareUrl } from "../../lib/basar";
import { useLang } from "../../context/LanguageContext";

/** «Del»-meny på den offentlege basarsida: Facebook (via /api/share/basar → delingskortet som førehandsvising) + kopier lenke. */
export const ShareMenu = ({ basarId, variant = "outline", size = "default", className = "" }) => {
  const { t } = useLang();
  const [copied, setCopied] = useState(false);
  const shareUrl = basarShareUrl(basarId);

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      setCopied(true);
      toast.success(t("Delingslenken er kopiert"));
      setTimeout(() => setCopied(false), 1800);
    } catch {
      toast.error(t("Kunne ikke kopiere – merk lenken og kopier manuelt"));
    }
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant={variant} size={size} className={className} data-testid="basar-share-menu-button"><Share2 className="w-4 h-4 mr-1.5" /> {t("Del")}</Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-56" data-testid="basar-share-menu">
        <DropdownMenuItem onSelect={() => openFacebookShare(shareUrl)} data-testid="basar-share-facebook-item"><Facebook className="w-4 h-4 mr-2" /> {t("Del på Facebook")}</DropdownMenuItem>
        <DropdownMenuItem onSelect={(e) => { e.preventDefault(); copyLink(); }} data-testid="basar-share-copy-item">{copied ? <Check className="w-4 h-4 mr-2 text-[hsl(var(--success))]" /> : <Link2 className="w-4 h-4 mr-2" />} {t("Kopier delingslenke")}</DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
